import { store } from '@/state/store';
import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';

export class UTILS__ml_asset {
  static get_by_hash(hash_sha256: string) {
    const { ml_assets_map } = store.getState().slice_ml_asset;

    /*
     * RESULT
     */

    let out = DTO__ml_asset.CREATE_STUB();

    for (let ml_asset of ml_assets_map.values()) {
      if (ml_asset.hash_sha256 != hash_sha256) continue;

      out = ml_asset;

      break;
    }

    return out;
  }

  static get_name_and_version(hash_sha256: string) {
    let ml_asset = UTILS__ml_asset.get_by_hash(hash_sha256);

    if (ml_asset.is_stub()) return [hash_sha256, ''];

    return [ml_asset.name, ml_asset.version];
  }

  static get_unet__by_family_name_version_inpaint(family: ENUM__ml_asset_family, name: string, version: string, is_inpaint: boolean, except_hashes: string[]) {
    const { ml_assets_map } = store.getState().slice_ml_asset;

    name = name.only_alphanumeric().toLowerCase();

    let out = DTO__ml_asset.CREATE_STUB();

    for (let ml_asset of ml_assets_map.values()) {
      if (except_hashes.includes(ml_asset.hash_sha256)) continue;
      if (ml_asset.type != ENUM__ml_asset_type.UNET) continue;
      if (ml_asset.family != family) continue;
      if (ml_asset.config.get_unet_is_inpaint() != is_inpaint) continue;
      if (ml_asset.version != version) continue;

      let name_no_emoji = ml_asset.name.only_alphanumeric().toLowerCase();
      if (name_no_emoji != name) continue;

      out = ml_asset;
      break;
    }

    return out;
  }

  static get_unet__by_family_name_inpaint(family: ENUM__ml_asset_family, name: string, is_inpaint: boolean, except_hashes: string[]) {
    const { ml_assets_map } = store.getState().slice_ml_asset;

    name = name.only_alphanumeric().toLowerCase();

    let out = DTO__ml_asset.CREATE_STUB();

    for (let ml_asset of ml_assets_map.values()) {
      if (except_hashes.includes(ml_asset.hash_sha256)) continue;
      if (ml_asset.type != ENUM__ml_asset_type.UNET) continue;
      if (ml_asset.family != family) continue;
      if (ml_asset.config.get_unet_is_inpaint() != is_inpaint) continue;

      let name_no_emoji = ml_asset.name.only_alphanumeric().toLowerCase();
      if (name_no_emoji != name) continue;

      out = ml_asset;
      break;
    }

    return out;
  }

  static get_unet__by_family_inpaint(family: ENUM__ml_asset_family, is_inpaint: boolean, except_hashes: string[]) {
    const { ml_assets_map } = store.getState().slice_ml_asset;

    let out = DTO__ml_asset.CREATE_STUB();

    for (let ml_asset of ml_assets_map.values()) {
      if (except_hashes.includes(ml_asset.hash_sha256)) continue;
      if (ml_asset.type != ENUM__ml_asset_type.UNET) continue;
      if (ml_asset.family != family) continue;
      if (ml_asset.config.get_unet_is_inpaint() != is_inpaint) continue;

      out = ml_asset;
      break;
    }

    return out;
  }
}
